module.exports = __webpack_public_path__ + "img/table-employees.3b91ba34.svg";